"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
const TabContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabContainer",
  class: "pl-t1fhxboh",
  vars: {
    "t1fhxboh-1": [({
      isActive
    }) => isActive ? `0.125rem solid ${_intents.default.ux.boxHighContrast.borderColor}` : '0.125rem solid transparent'],
    "t1fhxboh-3": [({
      isActive
    }) => isActive ? _intents.default.ux.box.backgroundColor : _intents.default.ux.boxLowContrastOverlay.backgroundColor]
  }
});
const TabName = /*#__PURE__*/(0, _react2.styled)("h3")({
  name: "TabName",
  class: "pl-t19w011k"
});
const TabDescription = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "TabDescription",
  class: "pl-t1vfcctc"
});

/**
 * Tab Component.
 * @module Tab
 *
 * @param {Object} props React props
 * @param {String} props.id An unique identifier
 * @param {String} props._name Tracking Name
 * @param {String} props.label Tab Label
 * @param {String} props.description Tab Description
 * @param {Boolean} props.isActive
 * @param {Boolean} props.switchTab
 * @param {String} props.lineupName Tab Lineup Name
 * @param {Array} props.items an Array of Plan Box Items
 * @returns {React.ReactElement} Tab Component
 * @public
 */

function Tab({
  id,
  _name,
  label,
  description,
  isActive,
  switchTab,
  lineupName,
  items
}) {
  return /*#__PURE__*/_react.default.createElement(TabContainer, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "tab-item",
    isActive: isActive,
    onClick: () => switchTab(id, lineupName, items)
  }, _patternLibraryUtils.tracking.create(_name, true, false)), /*#__PURE__*/_react.default.createElement(TabName, null, label), /*#__PURE__*/_react.default.createElement(TabDescription, null, description));
}
var _default = exports.default = Tab;
Tab.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  label: _propTypes.default.string,
  description: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  switchTab: _propTypes.default.func,
  lineupName: _propTypes.default.string,
  items: _propTypes.default.array
};